<template>
  <div>

    <div class="fx__box fx__active" style="margin-bottom:10px;">
      <div style="display:flex;justify-content: space-between;align-items: center;" @click="execution('app-pad-user-face')">
        <span style="font-size:16px;font-weight: bold;">修改头像</span>
        <div style="display:flex">
          <core-avatar :size="50" :userid="$store.state.core.user.userid" :username="$store.state.core.user.cnname" />
        </div>
      </div>
    </div>
    <div class="fx__box fx__active" style="margin-bottom:10px;">
      <div style="display:flex;justify-content: space-between;align-items: center;">
        <span style="font-size:16px;font-weight: bold;">昵称</span>
        <div style="display:flex">
          <span style="font-size:14px">{{cnname}}</span>
        </div>
      </div>
    </div>
    <div class="fx__box fx__active" style="margin-bottom:10px;">
      <div style="display:flex;justify-content: space-between;align-items: center;" @click="onclickusername">
        <span style="font-size:16px;font-weight: bold;">用户名</span>
        <div style="display:flex">
          <span style="font-size:14px">{{username}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
let timer = null
// 该时间间隔内点击才算连续点击（单位：ms）
let waitTime = 500
// 连续点击次数
let num = 0
// 最大连续点击次数
let maxNum = 5
// 上次的点击时间
let lastTime = new Date().getTime()

function lianxudianji(callback) {
  let nowTime = new Date().getTime()
  if (nowTime - lastTime < waitTime) {
    num++
  } else {
    num = 0
  }
  lastTime = nowTime
  if (num >= maxNum) {
    num = 0
    clearTimeout(timer)
    timer = setTimeout(() => {
      callback()
    }, 100)
  }
}

export default {
  data() {
    let { cnname, username, userid } = this.$store.state.core.user

    return {
      modal6: false,
      cnname,
      username,
      userid,
    }
  },

  methods: {
    execution(url) {
      if (url) {
        this.$router.push({ name: url })
      }
      // else {
      //   this.$Message.warning("待开发");
      // }
    },
    onclickusername() {
      lianxudianji(() => {
        let g = window.localStorage.getItem("phonedebug")

        if (g == "1") {
          g = "0"
        } else {
          g = "1"
        }
        window.localStorage.setItem("phonedebug", g)
        if (g == "1") {
          this.$toast.success("进入调试模式,1s后刷新界面")
        } else {
          this.$toast.success("退出调试模式,1s后刷新界面")
        }
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      })
    },
    // if (i.name === "头像") {
    //   this.userOptions();
    // } else if (i.name === "修改密码") {
    //   this.accountSetting();
    // } else {
    //   this.$Message.warning("待开发");
    // }

    // accountSetting() {
    //   this.$router.push({ name: "core-accountSetting" });
    // },
    // userOptions() {
    //   this.$router.push({ name: "core-personalSetting" });
    // }
  },
  created() {
    // this.createAt = createAt;
  },
}
</script>